module.exports = __webpack_public_path__ + "assets/img/5may_dark.c6a5f7a0.jpeg";